import script from "./rate-items-on-a-scale.vue?vue&type=script&setup=true&lang=js"
export * from "./rate-items-on-a-scale.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__